import { render, staticRenderFns } from "./footerComponent.vue?vue&type=template&id=26b589b8&scoped=true"
import script from "./footerComponent.vue?vue&type=script&lang=js"
export * from "./footerComponent.vue?vue&type=script&lang=js"
import style0 from "./footerComponent.vue?vue&type=style&index=0&id=26b589b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b589b8",
  null
  
)

export default component.exports